import {ProductVintage} from 'modules/products/components/ProductVintage';
import style from './style.module.scss';
import {IVintage} from 'modules/products/types';
import {FC} from 'react';

interface IProps {
    vintages?: IVintage[];
    code?: string;
}

const ProductVintagesBlock: FC<IProps> = ({vintages = [], code = ''}) => (
    <div className={style.blockFooter}>
        <ProductVintage items={vintages} parentCode={code} />
    </div>
);

export default ProductVintagesBlock;
